/** Texts of the platform's mail: the mails themselves, the pages behind their links, the sender's setup. Each key in both languages. */
export const mail = {
  en: {
    "err.emailUnconfirmed": "Confirm your e-mail address first — the link is in the mail we sent you.",
    "err.linkInvalid": "This link is no longer valid — it was used already or has expired. Ask for a new one.",
    "err.mail.missing": "The platform does not send mail yet. An administrator sets it up under Settings → Platform.",
    "err.mail.refused": "The mail server refused the sign-in. Check the user name and the password.",
    "err.mail.unreachable": "The mail server could not be reached: {message}",
    "err.mail.failed": "The mail could not be sent: {message}",

    "mail.signature": "— {app}",
    "mail.verify.subject": "Confirm your address for {app}",
    "mail.verify.body": "Hello {name},\n\nthank you for registering with {app}. Please confirm your e-mail address with this link — it is valid for 24 hours:\n\n{link}\n\nIf you did not register, ignore this mail; the account stays closed.",
    "mail.reset.subject": "Set a new password for {app}",
    "mail.reset.body": "Hello {name},\n\nsomeone asked to set a new password for your account at {app}. This link lets you set one — it is valid for one hour:\n\n{link}\n\nIf it was not you, ignore this mail; your password stays as it is.",
    "mail.newEmail.subject": "Confirm your new address for {app}",
    "mail.newEmail.body": "Hello {name},\n\nyou want to sign in to {app} with {email} from now on. Please confirm it with this link — it is valid for 24 hours:\n\n{link}\n\nUntil then your previous address stays the one to sign in with. If it was not you, ignore this mail.",
    "mail.newAccount.subject": "New account at {app}: {user}",
    "mail.newAccount.body": "Hello {name},\n\n{user} ({email}) has just registered at {app}. The account counts once the address is confirmed.\n\nThe users: {link} → Settings → Users",
    "mail.test.subject": "Test mail from {app}",
    "mail.test.body": "Hello {name},\n\nthis is a test mail from {app} ({link}). Mail is set up correctly.",

    "auth.forgot": "Forgot password?",
    "auth.toSignIn": "To sign in",
    "auth.resend": "Send the confirmation link again",
    "auth.resent": "If the address is waiting for its confirmation, a new link is on its way.",
    "auth.sent.title": "Check your mail",
    "auth.sent.body": "We sent a link to {email}. Open it within 24 hours to confirm your address — then you can sign in.",
    "auth.forgot.title": "Forgot password",
    "auth.forgot.intro": "Enter your e-mail address. We send you a link to set a new password.",
    "auth.forgot.send": "Send link",
    "auth.forgot.sentTitle": "Check your mail",
    "auth.forgot.sentBody": "If there is an account for {email}, a link to set a new password is on its way. It is valid for one hour.",
    "auth.reset.title": "Set a new password",
    "auth.reset.intro": "Choose a new password. Every device signed in to your account is signed out.",
    "auth.reset.password": "New password",
    "auth.reset.save": "Save password",
    "auth.reset.doneTitle": "Password changed",
    "auth.reset.doneBody": "Sign in with your new password.",
    "auth.confirm.title": "Confirm your address",
    "auth.confirm.intro": "One click confirms your e-mail address.",
    "auth.confirm.button": "Confirm address",
    "auth.confirm.verify.title": "Address confirmed",
    "auth.confirm.verify.body": "Your account is ready. Sign in now.",
    "auth.confirm.email.title": "New address confirmed",
    "auth.confirm.email.body": "Sign in with your new address from now on.",

    "profile.emailPending": "We sent a link to {email}. Your new address counts once you open it; until then you sign in with the previous one.",

    "set.mail.row": "Mail",
    "set.mail.hint": "Sends the account mails: confirming the address of a new account, a forgotten password, a new address, a note to the administrators on a new registration.",
    "set.mail.none": "Not set up — accounts are open at once, no password reset by mail",
    "set.mail.sending": "Sends as {sender} via {server}",
    "set.mail.setUp": "Set up",
    "set.mail.change": "Change",
    "set.mail.title": "Set up mail",
    "set.mail.intro": "The SMTP data of the service the mails go out through. The ⓘ explains the free way with Brevo step by step.",
    "set.mail.guide.label": "Guide",
    "set.mail.guide.title": "Guide: free mail with Brevo",
    "set.mail.guide.intro": "netcup blocks the usual mail ports 25, 465 and 587 on the server. The mails therefore go through a sending service on port 2525 — Brevo sends up to 300 mails a day for free.",
    "set.mail.guide.account.title": "Account",
    "set.mail.guide.account.1": "Register on brevo.com with the „Free“ plan, confirm your e-mail address and fill in the company details.",
    "set.mail.guide.domain.title": "Confirm the domain",
    "set.mail.guide.domain.1": "At the top right on your name → Settings → Senders, Domains, IPs → tab Domains → Add a domain → {domain} → „Manual“ (shared IPs, if asked).",
    "set.mail.guide.domain.2": "Brevo shows the DNS records. Add each with „Copy“ as a new record in the netcup CCP → your domain → CloudDNS, the host name without „.{domain}“:",
    "set.mail.guide.domain.3": "Once netcup has deployed the zone: „Verify records“ in Brevo, then „Authenticate domain“. Red usually only means too early — check again later.",
    "set.mail.guide.col.host": "Host name",
    "set.mail.guide.col.type": "Type",
    "set.mail.guide.col.value": "Target / data",
    "set.mail.guide.sender.title": "Sender",
    "set.mail.guide.sender.1": "In the tab Senders add the sender address, e.g. no-reply@{domain} — no mailbox of its own needed.",
    "set.mail.guide.key.title": "SMTP key and this window",
    "set.mail.guide.key.1": "At the top right on your name → SMTP & API → tab SMTP: „Generate a new SMTP key“ — copy it at once, it is shown only once. The „Login“ beside it ends in @smtp-brevo.com.",
    "set.mail.guide.key.2": "Then here:",
    "set.mail.guide.field.host": "smtp-relay.brevo.com",
    "set.mail.guide.field.securityLabel": "STARTTLS",
    "set.mail.guide.field.port": "2525 — after choosing STARTTLS change it by hand (587 is blocked)",
    "set.mail.guide.field.user": "the Login from Brevo (…@smtp-brevo.com)",
    "set.mail.guide.field.password": "the SMTP key (not the Brevo password)",
    "set.mail.guide.field.sender": "the address from step 3",
    "set.mail.guide.field.senderName": "as you like, e.g. Illustrading",
    "set.mail.guide.test.title": "Test",
    "set.mail.guide.test.1": "„Test and save“, then „Send test mail to me“ — look in the spam folder too.",
    "set.mail.guide.errors": "If it fails",
    "set.mail.guide.error.version": "„wrong version number“: set the encryption to STARTTLS.",
    "set.mail.guide.error.refused": "Sign-in refused: check the Login and the SMTP key.",
    "set.mail.guide.error.timeout": "Not reachable or timeout: port 2525 instead of 587 or 465.",
    "set.mail.host": "SMTP server",
    "set.mail.securityLabel": "Encryption",
    "set.mail.security.ssl": "SSL/TLS",
    "set.mail.security.starttls": "STARTTLS",
    "set.mail.port": "Port",
    "set.mail.user": "User name",
    "set.mail.password": "Password",
    "set.mail.sender": "Sender address",
    "set.mail.senderHint": "Usually the mailbox's own address.",
    "set.mail.senderName": "Sender name",
    "set.mail.saveHint": "Saving signs in to the server first; the password is stored encrypted.",
    "set.mail.save": "Test and save",
    "set.mail.test": "Send test mail to me",
    "set.mail.testSent": "Test mail sent — look in your inbox (and the spam folder).",
    "set.mail.remove": "Remove mail",
    "set.mail.removeConfirm": "Remove the mail sender? New accounts are then open at once, and no password can be reset by mail.",

    "set.users.unconfirmed": "not confirmed",
    "set.users.unconfirmedHint": "The address is not confirmed yet: the account can sign in once the link in its mail is opened.",
  } as Record<string, string>,
  de: {
    "err.emailUnconfirmed": "Bestätige zuerst deine E-Mail-Adresse — der Link steht in der Mail, die wir dir geschickt haben.",
    "err.linkInvalid": "Dieser Link gilt nicht mehr — er wurde schon benutzt oder ist abgelaufen. Fordere einen neuen an.",
    "err.mail.missing": "Die Plattform verschickt noch keine Mails. Ein Administrator richtet das unter Einstellungen → Plattform ein.",
    "err.mail.refused": "Der Mailserver hat die Anmeldung abgelehnt. Prüfe Benutzername und Passwort.",
    "err.mail.unreachable": "Der Mailserver war nicht erreichbar: {message}",
    "err.mail.failed": "Die Mail konnte nicht gesendet werden: {message}",

    "mail.signature": "— {app}",
    "mail.verify.subject": "Bestätige deine Adresse für {app}",
    "mail.verify.body": "Hallo {name},\n\ndanke für deine Registrierung bei {app}. Bitte bestätige deine E-Mail-Adresse mit diesem Link — er gilt 24 Stunden:\n\n{link}\n\nHast du dich nicht registriert, ignoriere diese Mail; das Konto bleibt gesperrt.",
    "mail.reset.subject": "Neues Passwort für {app}",
    "mail.reset.body": "Hallo {name},\n\nfür dein Konto bei {app} wurde ein neues Passwort angefordert. Mit diesem Link setzt du es — er gilt eine Stunde:\n\n{link}\n\nWarst du das nicht, ignoriere diese Mail; dein Passwort bleibt, wie es ist.",
    "mail.newEmail.subject": "Bestätige deine neue Adresse für {app}",
    "mail.newEmail.body": "Hallo {name},\n\ndu willst dich bei {app} ab jetzt mit {email} anmelden. Bitte bestätige das mit diesem Link — er gilt 24 Stunden:\n\n{link}\n\nBis dahin meldest du dich weiter mit deiner bisherigen Adresse an. Warst du das nicht, ignoriere diese Mail.",
    "mail.newAccount.subject": "Neues Konto bei {app}: {user}",
    "mail.newAccount.body": "Hallo {name},\n\n{user} ({email}) hat sich gerade bei {app} registriert. Das Konto gilt, sobald die Adresse bestätigt ist.\n\nDie Benutzer: {link} → Einstellungen → Benutzer",
    "mail.test.subject": "Testmail von {app}",
    "mail.test.body": "Hallo {name},\n\ndas ist eine Testmail von {app} ({link}). Der Mail-Versand ist richtig eingerichtet.",

    "auth.forgot": "Passwort vergessen?",
    "auth.toSignIn": "Zur Anmeldung",
    "auth.resend": "Bestätigungslink erneut senden",
    "auth.resent": "Wartet die Adresse auf ihre Bestätigung, ist ein neuer Link unterwegs.",
    "auth.sent.title": "Schau in dein Postfach",
    "auth.sent.body": "Wir haben dir einen Link an {email} geschickt. Öffne ihn innerhalb von 24 Stunden, um deine Adresse zu bestätigen — danach kannst du dich anmelden.",
    "auth.forgot.title": "Passwort vergessen",
    "auth.forgot.intro": "Gib deine E-Mail-Adresse ein. Wir schicken dir einen Link, mit dem du ein neues Passwort setzt.",
    "auth.forgot.send": "Link senden",
    "auth.forgot.sentTitle": "Schau in dein Postfach",
    "auth.forgot.sentBody": "Gibt es ein Konto zu {email}, ist ein Link für ein neues Passwort unterwegs. Er gilt eine Stunde.",
    "auth.reset.title": "Neues Passwort setzen",
    "auth.reset.intro": "Wähle ein neues Passwort. Alle Geräte, die mit deinem Konto angemeldet sind, werden abgemeldet.",
    "auth.reset.password": "Neues Passwort",
    "auth.reset.save": "Passwort speichern",
    "auth.reset.doneTitle": "Passwort geändert",
    "auth.reset.doneBody": "Melde dich mit deinem neuen Passwort an.",
    "auth.confirm.title": "Adresse bestätigen",
    "auth.confirm.intro": "Ein Klick bestätigt deine E-Mail-Adresse.",
    "auth.confirm.button": "Adresse bestätigen",
    "auth.confirm.verify.title": "Adresse bestätigt",
    "auth.confirm.verify.body": "Dein Konto ist bereit. Melde dich jetzt an.",
    "auth.confirm.email.title": "Neue Adresse bestätigt",
    "auth.confirm.email.body": "Melde dich ab jetzt mit deiner neuen Adresse an.",

    "profile.emailPending": "Wir haben einen Link an {email} geschickt. Die neue Adresse gilt, sobald du ihn öffnest; bis dahin meldest du dich mit der bisherigen an.",

    "set.mail.row": "E-Mail-Versand",
    "set.mail.hint": "Verschickt die Mails zum Konto: Bestätigung der Adresse eines neuen Kontos, Passwort vergessen, neue Adresse, Hinweis an die Administratoren bei einer neuen Registrierung.",
    "set.mail.none": "Nicht eingerichtet — Konten sind sofort offen, kein Zurücksetzen des Passworts per Mail",
    "set.mail.sending": "Sendet als {sender} über {server}",
    "set.mail.setUp": "Einrichten",
    "set.mail.change": "Ändern",
    "set.mail.title": "E-Mail-Versand einrichten",
    "set.mail.intro": "Die SMTP-Daten des Dienstes, über den die Mails rausgehen. Das ⓘ erklärt den kostenlosen Weg mit Brevo Schritt für Schritt.",
    "set.mail.guide.label": "Anleitung",
    "set.mail.guide.title": "Anleitung: kostenloser Versand mit Brevo",
    "set.mail.guide.intro": "netcup sperrt auf dem Server die üblichen Mailports 25, 465 und 587. Die Mails gehen deshalb über einen Versanddienst mit Port 2525 — Brevo verschickt kostenlos bis zu 300 Mails am Tag.",
    "set.mail.guide.account.title": "Konto",
    "set.mail.guide.account.1": "Auf brevo.com im Tarif „Free“ registrieren, die E-Mail-Adresse bestätigen und die Angaben zum Unternehmen ausfüllen.",
    "set.mail.guide.domain.title": "Domain bestätigen",
    "set.mail.guide.domain.1": "Oben rechts auf deinen Namen → Settings → Senders, Domains, IPs → Reiter Domains → Add a domain → {domain} → „Manual“ (falls gefragt: gemeinsam genutzte IPs).",
    "set.mail.guide.domain.2": "Brevo zeigt die DNS-Einträge. Jeden über „Copy“ als neuen Record im netcup-CCP → deine Domain → CloudDNS eintragen, den Hostnamen ohne „.{domain}“:",
    "set.mail.guide.domain.3": "Wenn netcup die Zone bereitgestellt hat: in Brevo „Verify records“, dann „Authenticate domain“. Rot heißt meist nur: noch zu früh — später erneut prüfen.",
    "set.mail.guide.col.host": "Hostname",
    "set.mail.guide.col.type": "Typ",
    "set.mail.guide.col.value": "Ziel / Daten",
    "set.mail.guide.sender.title": "Absender",
    "set.mail.guide.sender.1": "Im Reiter Senders die Absender-Adresse anlegen, z. B. no-reply@{domain} — ein eigenes Postfach ist nicht nötig.",
    "set.mail.guide.key.title": "SMTP-Schlüssel und dieses Fenster",
    "set.mail.guide.key.1": "Oben rechts auf deinen Namen → SMTP & API → Reiter SMTP: „Generate a new SMTP key“ — sofort kopieren, er wird nur einmal gezeigt. Der „Login“ daneben endet auf @smtp-brevo.com.",
    "set.mail.guide.key.2": "Dann hier eintragen:",
    "set.mail.guide.field.host": "smtp-relay.brevo.com",
    "set.mail.guide.field.securityLabel": "STARTTLS",
    "set.mail.guide.field.port": "2525 — nach der Wahl von STARTTLS von Hand ändern (587 ist gesperrt)",
    "set.mail.guide.field.user": "der Login von Brevo (…@smtp-brevo.com)",
    "set.mail.guide.field.password": "der SMTP-Schlüssel (nicht das Brevo-Passwort)",
    "set.mail.guide.field.sender": "die Adresse aus Schritt 3",
    "set.mail.guide.field.senderName": "frei wählbar, z. B. Illustrading",
    "set.mail.guide.test.title": "Testen",
    "set.mail.guide.test.1": "„Testen und speichern“, dann „Testmail an mich senden“ — auch im Spam-Ordner nachsehen.",
    "set.mail.guide.errors": "Wenn es hakt",
    "set.mail.guide.error.version": "„wrong version number“: Verschlüsselung auf STARTTLS stellen.",
    "set.mail.guide.error.refused": "Anmeldung abgelehnt: Login und SMTP-Schlüssel prüfen.",
    "set.mail.guide.error.timeout": "Nicht erreichbar oder Zeitüberschreitung: Port 2525 statt 587 oder 465.",
    "set.mail.host": "SMTP-Server",
    "set.mail.securityLabel": "Verschlüsselung",
    "set.mail.security.ssl": "SSL/TLS",
    "set.mail.security.starttls": "STARTTLS",
    "set.mail.port": "Port",
    "set.mail.user": "Benutzername",
    "set.mail.password": "Passwort",
    "set.mail.sender": "Absender-Adresse",
    "set.mail.senderHint": "Meist die Adresse des Postfachs selbst.",
    "set.mail.senderName": "Absender-Name",
    "set.mail.saveHint": "Beim Speichern meldet sich die Plattform zuerst am Server an; das Passwort wird verschlüsselt gespeichert.",
    "set.mail.save": "Testen und speichern",
    "set.mail.test": "Testmail an mich senden",
    "set.mail.testSent": "Testmail gesendet — schau in dein Postfach (und in den Spam-Ordner).",
    "set.mail.remove": "E-Mail-Versand entfernen",
    "set.mail.removeConfirm": "E-Mail-Versand entfernen? Neue Konten sind dann sofort offen, und kein Passwort lässt sich per Mail zurücksetzen.",

    "set.users.unconfirmed": "nicht bestätigt",
    "set.users.unconfirmedHint": "Die Adresse ist noch nicht bestätigt: Das Konto kann sich anmelden, sobald der Link in seiner Mail geöffnet wurde.",
  } as Record<string, string>,
};
